import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import PropTypes from "prop-types";
import { calculateRem } from "@uie/javascript-style-helpers";
import { Button as CoreButton } from "@vds-core/buttons";
var propTypes = {
  /**
   * If true, will render a Primary button (default).
   */
  primary: PropTypes.bool,
  /**
   * If true, will render a Secondary Button.
   */
  secondary: PropTypes.bool,
  /**
   * Component will render in Inverted state.
   */
  inverted: PropTypes.bool
};
var defaultProps = {
  inverted: false,
  primary: false,
  secondary: false
};
var Button = function Button(props) {
  var width = props.width,
    size = props.size,
    inverted = props.inverted,
    secondary = props.secondary;
  function _calculateButtonHeight(size) {
    var height;
    if (size === "small") {
      height = calculateRem(28);
    } else {
      height = calculateRem(44);
    }
    return height;
  }
  function _calculateBorderRadius(size) {
    return calculateRem(100);
  }
  function _calculateSideMargin(size, width) {
    var sideMargin, verticalMargin;
    if (size === "small") {
      sideMargin = 16;
      verticalMargin = 5;
    } else {
      sideMargin = width === "auto" ? 44 : 22;
      verticalMargin = 11;
    }
    return calculateRem(verticalMargin, sideMargin);
  }
  function _calculateMinWidth(size) {
    return undefined;
  }
  return /*#__PURE__*/React.createElement(CoreButton, _extends({}, props, {
    use: secondary ? "secondary" : "primary",
    surface: inverted ? "dark" : "light",
    width: size === "small" ? "auto" : width,
    calculateButtonHeight: _calculateButtonHeight,
    calculateSideMargin: _calculateSideMargin,
    calculateBorderRadius: _calculateBorderRadius,
    calculateMinWidth: _calculateMinWidth,
    calculateFontWeight: 700
  }));
};
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
Button.displayName = "Button";
export default Button;